@if (!isLoading) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>Activity</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-activity-save-btn" role="button" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-activity-reset-btn" role="button" class="ot-btn ot-btn--is-secondary"
          (click)="reset()" [disabled]="!settingsForm.dirty" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <form [formGroup]="settingsForm" name="otsc-settings-activity-form">
    <div class="ot-pt-1 ot-pb-1 ot-pl-1" style="height: calc(100vh - 150px);">
      <ng-scrollbar #scrollbarRef>
        <div id="otsc-settings-activity-retry-on-error">
          <app-checkbox [identifier]="'enableRetryOnError'" formControlName="enableRetryOnErrorCtrl"
            [name]="'enableRetryOnError'" [toggle]="true" i18n-label [label]="'Retry activities with an error'"
            i18n-description
            [description]="'When this setting is enabled, users can attempt to retry an activity within the specified period after encountering an error. A retry action menu will be accessible on the Activities Overview page for the activities that support this feature.'"
            i18n-arialabel [arialabel]="'Enable or disable retrying activities with an error'">
          </app-checkbox>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-33">
              <div class="ot-form-control"
                [ngClass]="{'ot-form-control--is-invalid' : enableRetryOnErrorCtrl.value == true && enableRetryOnErrorPeriodCtrl.invalid}">
                <label class="ot-form-control__label" for="enableRetryOnErrorPeriod" i18n>
                  Retry error period (hours)
                </label>
                <div class="ot-form-control__input-group">
                  <input id="enableRetryOnErrorPeriod" formControlName="enableRetryOnErrorPeriodCtrl"
                    placeholder="Enter retry on error period" type="number" min="1" max="72"
                    class="ot-input ot-input--is-expanded" [readonly]="!enableRetryOnErrorCtrl.value">
                  <span class="ot-form-control__error-icon">
                  </span>
                </div>
                @if (enableRetryOnErrorPeriodCtrl.invalid) {
                <p id="invalidEnableRetryOnErrorPeriodMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                  Invalid period specified. Please select a time period between 1 and 72 hours.
                </p>
                }
                <p class="ot-form-control__info-text" i18n>The value can be set between 1 and 72 hours.</p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </form>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" id="otsc-settings-activity-loading" i18n>Loading...</div>
</div>
}